/**
 * @module Core/helper/util/Promissory
 */

/**
 * Encapsulates a Promise and provides `resolve()` and `reject()` methods.
 *
 * For example:
 *
 * ```javascript
 *  load() {
 *      this.loading = new Promissory();
 *      this.store.load();
 *
 *      return this.loading.promise;
 *  }
 *
 *  onStoreLoad(store, err) {
 *      if (err) {
 *          this.loading.resolve(this);
 *      }
 *      else {
 *          this.loading.reject(err);
 *      }
 *  }
 *
 * ```
 *
 * @internal
 */
export default class Promissory {
    static new(fn) {
        return new this(fn);
    }

    constructor(fn) {
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });

        if (fn) {
            fn(this);
        }
    }

    catch(fn) {
        this.promise = this.promise.catch(fn);

        return this;
    }

    finally(fn) {
        this.promise = this.promise.finally(fn);

        return this;
    }

    then(...args) {
        this.promise = this.promise.then(...args);

        return this;
    }
}
